//#region imports
import React, { FC, ReactNode } from 'react';

import Modal from 'components/Modal';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

//#endregion

interface IProps {
  open: boolean;
  className?: string;
  title?: string;
  actions?: ReactNode;
  onClose?: () => void;
  isDisplayCloseIcon?: boolean;
}

const ModalInfo: FC<IProps> = ({ onClose, title, actions, className, ...rest }) => {
  const { t } = useTranslation();

  return (
    <Modal
      hasCloseButton
      onClose={ onClose }
      title={ t('modal.info.title') }
      actions={
        <Button variant="contained" color="secondary" onClick={ onClose } size="medium">
          { t('action.close') }
        </Button>
      }
      { ...rest }
    >
      <Typography mb={ '20px' } variant="inherit" color={ 'inherit' } >{ t('modal.info.desc.0') }</Typography>
      <Typography mb={ '20px' } variant="inherit" color={ 'inherit' }>{ t('modal.info.desc.1') }</Typography>
      <Typography mb={ '20px' } variant="inherit" dangerouslySetInnerHTML={ { __html: t('modal.info.desc.2') } } color={ 'inherit' }/>
      <Typography mb={ '20px' } variant="inherit" dangerouslySetInnerHTML={ { __html: t('modal.info.desc.3') } } color={ 'inherit' }/>
      <Typography variant="inherit" dangerouslySetInnerHTML={ { __html: t('modal.info.desc.4') } } color={ 'inherit' }/>
    </Modal>
  );
};

export default ModalInfo;
